import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, vModelSelect as _vModelSelect, withDirectives as _withDirectives, createTextVNode as _createTextVNode, withCtx as _withCtx, createElementBlock as _createElementBlock, createStaticVNode as _createStaticVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/logo.svg'


const _withScopeId = n => (_pushScopeId("data-v-5a7506fc"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "d-flex main" }
const _hoisted_2 = { class: "form-container" }
const _hoisted_3 = {
  key: 1,
  class: "d-flex flex-column justify-content-center pb-4 align-items-center"
}
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  class: "register-logo",
  src: _imports_0,
  alt: "Logo"
}, null, -1))
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h3", { class: "bold-h3" }, "Crie uma conta", -1))
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "informative-form regular-p" }, "Insira os dados abaixo", -1))
const _hoisted_7 = { class: "register-form" }
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  for: "phone",
  class: "profile-label"
}, "Telefone", -1))
const _hoisted_9 = { class: "d-flex flex-column justify-content-start mb-1" }
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  for: "occupation",
  class: "profile-label"
}, "Cargo", -1))
const _hoisted_11 = /*#__PURE__*/_createStaticVNode("<option value=\"\" disabled selected hidden data-v-5a7506fc>Selecione seu cargo</option><option value=\"C-Level\" data-v-5a7506fc>C-Level</option><option value=\"Gerente\" data-v-5a7506fc>Gerente</option><option value=\"Coordenador\" data-v-5a7506fc>Coordenador</option><option value=\"Analista\" data-v-5a7506fc>Analista</option><option value=\"Técnico\" data-v-5a7506fc>Técnico</option><option value=\"Assistente\" data-v-5a7506fc>Assistente</option><option value=\"Corretor\" data-v-5a7506fc>Corretor</option><option value=\"Arquiteto\" data-v-5a7506fc>Arquiteto</option><option value=\"Outro\" data-v-5a7506fc>Outro</option>", 10)
const _hoisted_21 = [
  _hoisted_11
]
const _hoisted_22 = { class: "informative-checkbox-container" }
const _hoisted_23 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "fw500" }, "Termos de uso", -1))
const _hoisted_24 = { class: "lcts-button" }
const _hoisted_25 = { class: "informative-container" }
const _hoisted_26 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "informative-item-1 regular-p" }, "Já possui conta? ", -1))
const _hoisted_27 = { class: "informative-item-2 bold-p" }
const _hoisted_28 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("strong", null, "Login", -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_LoginCarousel = _resolveComponent("LoginCarousel")!
  const _component_AuthenticationEmail = _resolveComponent("AuthenticationEmail")!
  const _component_InputTextfield = _resolveComponent("InputTextfield")!
  const _component_MaskInput = _resolveComponent("MaskInput")!
  const _component_Password = _resolveComponent("Password")!
  const _component_InputCheckbox = _resolveComponent("InputCheckbox")!
  const _component_TermsOfUseContent = _resolveComponent("TermsOfUseContent")!
  const _component_Modal = _resolveComponent("Modal")!
  const _component_Button = _resolveComponent("Button")!
  const _component_RouterLink = _resolveComponent("RouterLink")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_LoginCarousel, { class: "hide-on-mobile" }),
    _createElementVNode("div", _hoisted_2, [
      (_ctx.showAuthCodeScreen)
        ? (_openBlock(), _createBlock(_component_AuthenticationEmail, {
            key: 0,
            "user-object": _ctx.userObj,
            registerEmail: _ctx.form.email
          }, null, 8, ["user-object", "registerEmail"]))
        : (_openBlock(), _createElementBlock("div", _hoisted_3, [
            _hoisted_4,
            _hoisted_5,
            _hoisted_6,
            _createElementVNode("form", _hoisted_7, [
              _createVNode(_component_InputTextfield, {
                onLctsInputTextFieldValue: _ctx.handleInputNameValue,
                onLctsInputTextFieldIsValid: _ctx.handleInputNameIsValid,
                type: "text",
                id: "name",
                name: "name",
                textLabel: "Nome",
                hasLabel: true,
                textPlaceholder: "Informe seu nome",
                width: "100%",
                height: "auto",
                modelValue: _ctx.form.name,
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.form.name) = $event)),
                isRequired: true,
                validator: "empty"
              }, null, 8, ["onLctsInputTextFieldValue", "onLctsInputTextFieldIsValid", "modelValue"]),
              _createVNode(_component_InputTextfield, {
                onLctsInputTextFieldValue: _ctx.handleInputEmailValue,
                onLctsInputTextFieldIsValid: _ctx.handleInputEmailIsValid,
                type: "email",
                id: "email",
                name: "email",
                textLabel: "E-mail",
                hasLabel: true,
                textPlaceholder: "Informe seu e-mail",
                width: "100%",
                height: "auto",
                modelValue: _ctx.form.email,
                "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.form.email) = $event)),
                isRequired: true,
                validator: "email"
              }, null, 8, ["onLctsInputTextFieldValue", "onLctsInputTextFieldIsValid", "modelValue"]),
              _createElementVNode("div", null, [
                _hoisted_8,
                _createVNode(_component_MaskInput, {
                  class: "phone-input",
                  modelValue: _ctx.form.phone,
                  "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.form.phone) = $event)),
                  mask: "(##) #####-####",
                  placeholder: "Informe seu telefone",
                  width: "100%",
                  height: "auto"
                }, null, 8, ["modelValue"])
              ]),
              _createVNode(_component_InputTextfield, {
                onLctsInputTextFieldValue: _ctx.handleInputCompanyValue,
                onLctsInputTextFieldIsValid: _ctx.handleInputCompanyIsValid,
                type: "text",
                id: "company",
                name: "company",
                textLabel: "Empresa",
                hasLabel: true,
                textPlaceholder: "Informe sua empresa",
                width: "100%",
                height: "auto",
                modelValue: _ctx.form.company,
                "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.form.company) = $event)),
                isRequired: true,
                validator: "empty"
              }, null, 8, ["onLctsInputTextFieldValue", "onLctsInputTextFieldIsValid", "modelValue"]),
              _createElementVNode("div", _hoisted_9, [
                _hoisted_10,
                _withDirectives(_createElementVNode("select", {
                  type: "text",
                  id: "occupation",
                  name: "occupation",
                  width: "100%",
                  height: "auto",
                  class: "profile-select",
                  "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.form.occupation) = $event)),
                  onChange: _cache[5] || (_cache[5] = ($event: any) => (_ctx.handleInputOccupationValue($event.target.value)))
                }, _hoisted_21, 544), [
                  [_vModelSelect, _ctx.form.occupation]
                ])
              ]),
              _createVNode(_component_Password, {
                isRegister: true,
                isConfirm: true,
                onValuePasswordChange: _ctx.handleInputPasswordValue,
                onValidPassword: _ctx.handleInputPasswordIsValid
              }, null, 8, ["onValuePasswordChange", "onValidPassword"]),
              _createElementVNode("div", _hoisted_22, [
                _createVNode(_component_InputCheckbox, {
                  onLctsCheckboxChanged: _ctx.handleCheckboxChange,
                  class: "regular-label"
                }, {
                  checkboxText: _withCtx(() => [
                    _createTextVNode(" Eu li e concordo com os "),
                    _createElementVNode("a", {
                      "data-toggle": "modal",
                      onClick: _cache[6] || (_cache[6] = 
//@ts-ignore
(...args) => (_ctx.openModal && _ctx.openModal(...args))),
                      "data-target": "#exampleModal",
                      class: "terms-text"
                    }, "Termos de uso"),
                    _createTextVNode(" da plataforma ")
                  ]),
                  _: 1
                }, 8, ["onLctsCheckboxChanged"])
              ]),
              _createVNode(_component_Modal, {
                isOpen: _ctx.isModalOpened,
                onModalClose: _ctx.closeModal,
                name: "first-modal"
              }, {
                header: _withCtx(() => [
                  _hoisted_23
                ]),
                content: _withCtx(() => [
                  _createVNode(_component_TermsOfUseContent)
                ]),
                footer: _withCtx(() => [
                  _createElementVNode("button", {
                    onClick: _cache[7] || (_cache[7] = 
//@ts-ignore
(...args) => (_ctx.closeModal && _ctx.closeModal(...args))),
                    class: "close-modal-btn"
                  }, "Declaro que li os termos de uso")
                ]),
                _: 1
              }, 8, ["isOpen", "onModalClose"]),
              _createElementVNode("div", _hoisted_24, [
                _createVNode(_component_Button, {
                  onLctsButtonClicked: _cache[8] || (_cache[8] = ($event: any) => (_ctx.handleButtonClick(_ctx.form))),
                  size: "large",
                  styleButton: "secondary",
                  text: "Continuar",
                  width: "100%",
                  disabled: !_ctx.formIsValid()
                }, null, 8, ["disabled"])
              ])
            ]),
            _createElementVNode("div", _hoisted_25, [
              _hoisted_26,
              _createElementVNode("label", _hoisted_27, [
                _createVNode(_component_RouterLink, {
                  to: { name: 'login' },
                  class: "informative-item-2"
                }, {
                  default: _withCtx(() => [
                    _hoisted_28
                  ]),
                  _: 1
                })
              ])
            ])
          ]))
    ])
  ]))
}